import store from 'store'
import { FRONTDESK_STORAGE_USER, LOCAL_STORAGE_SESSION_TAG_KEY, LOCAL_STORAGE_SIGNUP_COMPLETE, LOCAL_STORAGE_SOURCE_PATH, shareLinkPathList } from '../config/constants'
import { USER_TYPE } from '../config/form-settings'
export const prepareDataForSignUp = (sourceData) => {
  if (!sourceData) {
    return {}
  }
  const { userEmail, title, userPhone, userPassword, looking, userFullName, contractType } = sourceData
  const { phone, countryName, dialCode } = userPhone || {};

  const allowFrontDesk = store.get(FRONTDESK_STORAGE_USER) ? "1" : "0";

  return {
    email: userEmail,
    password: userPassword,
    name: userFullName,
    user_metadata: {
      name: userFullName,
      phone_number: phone ?? '',
      prefix: dialCode ?? '',
      user_type: looking ? looking : contractType ? contractType : 'Radiologist',
      title: title ?? '',
      home_facility: '',
      signature: '',
      country: countryName ?? '',
    },
  }
}
export const getToggleData = (contractType) => {
  let toggleAccess = {
    // admin: '0',
    enable_ai_dictation: true,
    enable_ai_template_selection: true,
    report_style: "free_text",
    available_for_assignment: '1',
    available_for_assignment_other: "1",
    auto_download_assigned_studies: "1",
    allowed_to_delete_study: '1',
    allowed_to_second_opinion: "0",
    allowed_to_ai_override: "1",
    allowed_to_request_review: "1",
    allowed_to_radiology_manager: "1",
    allowed_study_share_before_report: '1',
    allowed_to_access_front_desk: false,
    allowed_to_request_ai_overread: '0',
    allowed_to_add_notes: '1',
    allowed_to_edit_reports: '1',
    allowed_to_create_draft_reports: '1',
    allowed_to_create_preliminary_reports: '1',
    allowed_to_revise_reports: '0',
    allowed_to_finilize_reports: '0',
    allowed_to_view_billing: "0",
    allowed_to_edit_billing: "0",
  }

  if (contractType) {
    const userType = contractType.toLowerCase()
    if (userType == "radiologist") {
      toggleAccess = {
        ...toggleAccess,
        allowed_to_revise_reports: "1",
        allowed_to_finilize_reports: "1",
      }
    }
    if (userType == "radiographer") {
      toggleAccess = {
        ...toggleAccess,
      }
    }
    if (userType == "physician") {
      toggleAccess = {
        ...toggleAccess,
        available_for_assignment: "0",
        auto_download_assigned_studies: "0",
        allowed_to_edit_reports: "0",
        allowed_to_create_draft_reports: "0",
        allowed_to_create_preliminary_reports: "0",
      }
    }
    if (userType == "administrator" || userType == "management") {
      for (const key in toggleAccess) {
        toggleAccess[key] = "1";
      }
      toggleAccess.allowed_to_request_ai_overread = "0"
      toggleAccess.allowed_to_access_front_desk = false
    }
    if (userType == "coordinator") {
      toggleAccess = {
        ...toggleAccess,
        available_for_assignment: "0",
        auto_download_assigned_studies: "0",
        allowed_to_second_opinion: "1",
      }

    }
  }
  return toggleAccess
}

export const setSessionTag = (email) => {
  const currentDate = new Date()
  // const currentYear = currentDate.getFullYear()
  // const currentMonth = currentDate.getMonth() + 1
  // const currentMonthString = currentMonth < 10 ? '0' + currentMonth : currentMonth
  // const currentDayOfMonth = currentDate.getDate()
  // const currentDateString = currentDayOfMonth < 10 ? '0' + currentDayOfMonth : currentDayOfMonth
  const currentTimestamp = currentDate.getTime()
  // const re = / /gi
  // const dateString = currentYear + '-' + currentMonthString + '-' + currentDateString // currentDate.toDateString().toLowerCase().replace(re, '-')
  // const sessionTag = 'session_' + dateString + '-' + currentTimestamp
  const sessionTag = email + '_on_' + currentTimestamp
  store.set(LOCAL_STORAGE_SESSION_TAG_KEY, sessionTag)
}

export const getSessionTag = () => {
  return store.get(LOCAL_STORAGE_SESSION_TAG_KEY)
}

export const checkShareLink = () => {
  const sourcePath = store.get(LOCAL_STORAGE_SOURCE_PATH) || null;
  return sourcePath ? shareLinkPathList.includes(sourcePath) : false
}

/**
 * Marks the signup flow as complete in localStorage.
 * Called when the user reaches a success screen, preventing
 * back-navigation to previous signup steps.
 * @param {string} [successPath] - The success page path the user reached
 *   (e.g. 'success' or 'expedited-success'). Stored so the back-navigation
 *   guard can redirect to the same page the user originally saw.
 */
export const markSignupComplete = (successPath) => {
  store.set(LOCAL_STORAGE_SIGNUP_COMPLETE, successPath || true)
}

/**
 * Checks whether the signup flow has already been completed.
 * Used by signup containers to redirect users who attempt to
 * navigate back to pre-success screens after account creation.
 */
export const isSignupComplete = () => {
  return !!store.get(LOCAL_STORAGE_SIGNUP_COMPLETE)
}

/**
 * Returns the success page path stored by markSignupComplete,
 * or null if only a boolean flag was stored (legacy callers).
 */
export const getCompletedSignupPath = () => {
  const val = store.get(LOCAL_STORAGE_SIGNUP_COMPLETE)
  return typeof val === 'string' ? val : null
}

const SUCCESS_PATH_SEGMENTS = ['success', 'expedited-success']

export function applySignupBackNavigationGuard(currentPath, historyReplace, redirectUrlWhenComplete) {
  if (SUCCESS_PATH_SEGMENTS.includes(currentPath)) {
    markSignupComplete(currentPath)
    return false
  }
  if (isSignupComplete()) {
    historyReplace(redirectUrlWhenComplete)
    return true
  }
  return false
}

const waitForNeverBounce = (timeout = 10000, interval = 100) => {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();

    const checkNeverBounce = () => {
      if (typeof window._nb !== 'undefined' && window._nb.api) {
        resolve(window._nb);
      } else if (Date.now() - startTime > timeout) {
        reject(new Error('NeverBounce not loaded within timeout period'));
      } else {
        setTimeout(checkNeverBounce, interval);
      }
    };

    checkNeverBounce();
  });
};

export const verifyEmail = async (email) => {
  try {
    const _nb = await waitForNeverBounce();

    if (!_nb) {
      console.error('NeverBounce is not available');
      return {
        valid: false,
        result: null,
      };
    }

    const result = await new Promise((resolve, reject) => {
      _nb.api.getValidatePublic(
        email,
        (result) => resolve(result),
        (err) => reject(err)
      );
    });

    return {
      valid: result.is([0, 3, 4]),
      result,
    };
  } catch (error) {
    console.error(error);
    return {
      valid: false,
      result: null,
    };
  }
}